import fetchWithFallback from '../CMSFetcher/fetchWithFallback';
import { API_URL, FONTS_DISCOVER_ENDPOINT, FONTS_SEARCH_ENDPOINT } from '../../utils/endpoints';

export const getLandingsByCategory = async (language: string) => {
  const path = `get-landings-by-category/${language}/${'fonts'}`;
  return fetchWithFallback(path);
};

export const getAllFonts = async (offset: number) => {
  const response = await fetch(
    `${API_URL}${FONTS_DISCOVER_ENDPOINT}?source=picsart&only_pinned_items=true&offset=${offset}&shuffle_factor=312&market=website`,
  );
  return response.json();
};

export const getFontsByOffset = async (
  isPaid: boolean,
  offsetFilter: number,
  searchParams = 'fonts',
) => {
  let url = `${API_URL}${FONTS_SEARCH_ENDPOINT}?package_type=font&source=picsart&q=${searchParams}&offset=${offsetFilter}&sort=trending`;
  if (isPaid !== null) {
    url += `&is_paid=${isPaid}`;
  }

  const response = await fetch(url);

  return response.json();
};
